import { useState } from "react";
import "./CitiSsoIframeForm.css";
import { validateCitiSsoIframeUrl } from "./citiSsoIframeAllowlist";

const IFRAME_SANDBOX =
  "allow-scripts allow-forms allow-same-origin allow-popups allow-popups-to-escape-sandbox";

const CitiSsoIframeForm = () => {
  const [inputValue, setInputValue] = useState("");
  const [iframeUrl, setIframeUrl] = useState(null);
  const [formError, setFormError] = useState(null);

  const handleSubmit = (e) => {
    e.preventDefault();
    const result = validateCitiSsoIframeUrl(inputValue);
    if (!result.ok) {
      setFormError(result.error);
      setIframeUrl(null);
      return;
    }
    setFormError(null);
    setIframeUrl(result.url);
  };

  const handleInputChange = (e) => {
    setInputValue(e.target.value);
    if (formError) setFormError(null);
  };

  return (
    <div className="registration-container">
      {!iframeUrl && (
        <div className="registration-box">
          <h3 className="form-title">Citi SSO (iframe)</h3>

          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <span className="label-text">Citi Passport SSO login URL</span>

              <input
                type="text"
                value={inputValue}
                onChange={handleInputChange}
                className="input-box"
                placeholder="https://…/sso-login?client_id=…&redirect_path=…"
              />
            </div>

            <div className="submit-wrapper">
              <button type="submit" className="submit-btn">
                Open Citi SSO in iframe
              </button>
            </div>
          </form>

          {formError && (
            <div className="error-box" role="alert">
              <strong>Error:</strong> {formError}
            </div>
          )}
        </div>
      )}

      {iframeUrl && (
        <iframe
          title="citi-sso-redirect-frame"
          src={iframeUrl}
          sandbox={IFRAME_SANDBOX}
          allow="autoplay; fullscreen; encrypted-media"
          className="result-iframe"
        />
      )}
    </div>
  );
};

export default CitiSsoIframeForm;
